//Imports node_modules
import React, { useContext, useEffect } from 'react'
import Modal from 'react-modal';
import Cookies from 'universal-cookie';

//Imports Css
import './VerefyIdPage.css'

//Import Data
import { globalFunctions } from '../../../data/GlobalFunctions'

//Pagina onde o cliente selciona a entidade
const VerefyIdPage = (props) => {

    //--- Variaveis

    //Variaveis Locais

    //eslint-disable-next-line
    const { 
        VerefyIDPost,
    } = useContext(globalFunctions);

    //Tbm pode ter o removeCookie 
    const cookies = new Cookies();

    //--- Fim variaveis 

    //--- Funções

    useEffect(() => {
        localStorage.setItem("queryParams", "noOP");
        //Gera um novo id
        let guid = () => {
            let s4 = () => {
                return Math.floor((1 + Math.random()) * 0x10000)
                    .toString(16)
                    .substring(1);
            }
            //return id of format 'aaaaaaaa'-'aaaa'-'aaaa'-'aaaa'-'aaaaaaaaaaaa'
            return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4()
        }

        //Verifica se o cookie com o id unico do dispositivo já existe
        //var cookies = new Cookies();
        let generatedId = guid();

        if (cookies.get('uniqueDeviceID') == null) {
            //var cookies = new Cookies();

            //Isto é para quando o utilizador reiniciar o pc ele não perder as cookies
            var date = new Date();
            date.setTime(date.getTime() + (999*24*60*60*1000));
            
            cookies.set('uniqueDeviceID', generatedId, { path: '/', expires: date});
            
            VerefyIDPost(generatedId);
        } else {
            VerefyIDPost(cookies.get('uniqueDeviceID'));
        }

        // eslint-disable-next-line
    }, []);

    //--- Fim funções
    Modal.setAppElement('body');

    return (
        <div className="VerefyIdPage">
            <div style={{width: '100%', height: '100%', backgroundColor: '#59A250'}}></div>
        </div>
    )
}
export default VerefyIdPage